import React from 'react';

function TopComponent() {
    return (
    <div className="header">
        <div><h1>Granwood</h1></div>
        <div className="Top">
            <a href="/"><button>Pagrindinis</button></a>
            <a href="/granulators"><button>Granuliatoriai</button></a>
            <a href="/dziovyklos"><button>Džiovyklos pjuvenoms</button></a>
            <a href="/presai"><button>Briketų presai</button></a>
            <a href="/linija"><button>Fasavimo įranga</button></a>
            <a href="/smulkintuvai">><button>Smulkintuvai</button></a>
        </div>
    </div>
    )
   
}
export default TopComponent;